import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Icon } from "@iconify/react";
import moment from "moment";
import { convertCurrencyToSignNew } from "../../utils/Constant";

function PaymentSuccessCard({ amount, currency, date, onClose }) {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "95vh",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#F5CE6E",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Icon icon="mdi:check-bold" color="#fff" width={48} height={48} />
      </Box>

      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 800,
          color: "#222",
          mb: 1,
          textAlign: "center",
        }}
      >
        Thank You for Your Payment
      </Typography>

      {/* Subtitle */}
      <Typography
        sx={{
          color: "#555",
          mb: 4,
          fontSize: 16,
          maxWidth: 500,
          textAlign: "center",
          lineHeight: 1.6,
        }}
      >
        We are pleased to confirm that your payment has been received
        successfully. Your timely settlement is greatly appreciated, and we look
        forward to continuing to serve you with the highest level of excellence.
      </Typography>
      <Typography
        sx={{
          color: "#555",
          mb: 4,
          fontSize: 16,
          maxWidth: 500,
          textAlign: "center",
          lineHeight: 1.6,
        }}
      >
        You will receive a confirmation email with your payment details at your
        registered email address for your records.
      </Typography>

      {/* Payment Details */}
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          borderRadius: 3,
          p: 3,
          width: "100%",
          maxWidth: 500,
          mb: 4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Icon
            icon="mdi:credit-card-outline"
            width={20}
            height={20}
            color="#F5CE6E"
          />
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#777", mb: 0.5, fontWeight: 500 }}
            >
              Amount Paid:
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 18, mb: 2 }}>
              {convertCurrencyToSignNew(currency)}
              {amount.toFixed(2)}
            </Typography>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Icon icon="uiw:date" width={20} height={20} color="#F5CE6E" />
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#777", mb: 0.5, fontWeight: 500 }}
            >
              Date of Payment:
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 16 }}>
              {moment(date).format("MMMM DD, YYYY")}
            </Typography>
          </div>
        </div>
      </Box>

      {/* Button */}
      <button
        className="btn btn-primary fw-bold px-4 py-2"
        style={{ background: "#000080", border: "none" }}
        onClick={onClose}
      >
        Continue
      </button>
    </Box>
  );
}

export default PaymentSuccessCard;
